<template>
  <nav class="localnav">
    <ul :class="'clum-'+clum">
      <li v-for="item in list" :key="item.eng"><a :href="item.link" :data-eng="item.eng">{{ item.jp }}</a></li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
.localnav{
  overflow: hidden;
  margin: 0 0 6.4rem;
  @media screen and (max-width: module.$tab){
    margin: 0 0 4.8rem;
  }
  ul{
    display: grid;
    gap: .1rem;
    border-radius: .64rem;
    overflow: hidden;
    @for $i from 1 through 10{
      &.clum-#{$i}{
        grid-template-columns: repeat(#{$i}, 1fr);
        @media screen and (max-width: module.$phone){
          grid-template-columns: 1fr;
        }
      }
    }
    li{
      a{
        font-size: 1.08rem;
        line-height: 1.5;
        color: module.$border;
        @include module.texture(-1);
        display: block;
        padding: 1.2rem 0;
        text-align: center;
        @media screen and (max-width: module.$tab){
          font-size: 1rem;
        }
        &:after{
          content: attr(data-eng);
          font-size: .88rem;
          display: block;
        }
        &:hover{
          @include module.texture();
        }
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    clum: {
      type: String,
      required: false
    },
    list: {
      type: Array,
      required: false,
    }
  }
}
</script>
